import React, { useState } from 'react'
import Page from 'contexts/page'
import { UserPermissionsProvider } from 'contexts/unit-permissions'
import AbsenceStatsProvider from 'contexts/absence-stats'
import AbsenceAdjustmentsProvider from 'contexts/absence-adjustments'
import { useMe } from 'contexts/me'
import FutureEntries from './future-entries'
import Breakdown from 'pages/absence/components/breakdown'
import Modal from 'modals/dialog'
import AddToCalendar from 'components/add-to-calendar'

const MyAbsencePane = ({ hasFetchedAbsenceTypes, salt }) => {
    const { me } = useMe()

    const [addingToCalendar, setAddingToCalendar] = useState(null)

    if(!me) {
        return null
    }

    salt = `${salt}:me`

    return (
        <>
            <FutureEntries
                user={me}
                setAddingToCalendar={setAddingToCalendar}
                showWorkdaysAffected={true}
                hasFetchedAbsenceTypes={hasFetchedAbsenceTypes}
                salt={salt} />
            <Breakdown
                user={me}
                setAddingToCalendar={setAddingToCalendar}
                showWorkdaysAffected={true}
                salt={salt} />
            <Modal
                salt={`${salt}:add-to-calendar`}
                show={!!addingToCalendar}
                className="scrollable"
                dismiss={() => setAddingToCalendar(null)}>
                <AddToCalendar
                    {...addingToCalendar}
                    dismiss={() => setAddingToCalendar(null)} />
            </Modal>
        </>
    )
}

export default ({ title, upgradable, ...props }) => (
    <Page
        view="absence_me"
        title={title}
        upgrade={{
            enabled: upgradable,
            tutorial: {
                which: 'absence',
                upgrade: { module: 'absence' }
            }
        }}>
        <UserPermissionsProvider id="me">
            <AbsenceStatsProvider userId="me">
                <AbsenceAdjustmentsProvider userId="me">
                    <MyAbsencePane {...props} />
                </AbsenceAdjustmentsProvider>
            </AbsenceStatsProvider>
        </UserPermissionsProvider>
    </Page>
)